export const CONNECTED_EVENT = "connected";
export const DISCONNECT_EVENT = "disconnect";
export const JOIN_CHAT_EVENT = "joinChat";
export const NEW_CHAT_EVENT = "newChat";
export const TYPING_EVENT = "typing";
export const STOP_TYPING_EVENT = "stopTyping";
export const MESSAGE_RECEIVED_EVENT = "messageReceived";
export const LEAVE_CHAT_EVENT = "leaveChat";
export const UPDATE_GROUP_NAME_EVENT = "updateGroupName";
export const MESSAGES_READ_STATUS_EVENT = "messagesReadStatus";
export const MESSAGE_RECEIVED_STATUS_EVENT = "messageReceivedStatus";
export const MESSAGE_EDITED_EVENT = "messageEdited";
export const MESSAGE_READ_EVENT = "messageRead";
export const MESSAGE_REACTION_EVENT = "messageReaction";
export const PIN_MESSAGE_EVENT = "pinMessage";
export const MESSAGE_DELETED_EVENT = "messageDeleted";
export const PROFILE_UPDATED_EVENT = "profileUpdated";
export const GROUP_UPDATED_EVENT = "groupUpdated";
export const GROUP_CREATED_EVENT = "groupCreated";
export const GROUP_DELETED_EVENT = "groupDeleted";
export const GROUP_LEFT_EVENT = "groupLeft";
export const MEMBER_ADDED_EVENT = "memberAdded";
export const MEMBER_REMOVED_EVENT = "memberRemovedEvent";
export const MESSAGE_STARRED_EVENT = "messageStarred";
